export async function loadGSAP() {
  await window.siteLoadOnce(
    'https://cdn.jsdelivr.net/npm/gsap@3.14.2/dist/gsap.min.js'
  );
}
